const actions = {
  SET_STATE: 'menu/SET_STATE',
  GET_DATA: 'menu/GET_DATA',
  REFRESH_MENU: 'menu/REFRESH_MENU',
  UPDATE_INBOX_COUNT: 'menu/UPDATE_INBOX_COUNT',
 
}

export default actions
